import React, { useState } from 'react';
import { Database } from 'lucide-react';
import { cn } from '../../lib/utils';
import { getCatalogThumbVariant } from '../../lib/catalogSampleDisplay';

const CatalogSampleThumbnail = ({ url, seed }) => {
  const [failed, setFailed] = useState(false);
  const { paletteClass, patternAngle, hueRotate, scale } = getCatalogThumbVariant(seed);
  const showImage = Boolean(url) && !failed;

  return (
    <div className={cn('relative h-full w-full overflow-hidden', paletteClass)}>
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage: `repeating-linear-gradient(${patternAngle}deg, transparent, transparent 14px, rgba(255,255,255,0.1) 14px, rgba(255,255,255,0.1) 28px)`
        }}
        aria-hidden
      />
      {showImage ? (
        <img
          src={url}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-[0.88] transition-transform duration-300 group-hover:scale-[1.04]"
          style={{
            filter: `hue-rotate(${hueRotate}deg) saturate(1.12)`,
            transform: `scale(${scale})`
          }}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center" aria-hidden>
          <Database className="text-white/40 dark:text-white/25" size={32} strokeWidth={1.5} />
        </div>
      )}
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-black/10"
        aria-hidden
      />
    </div>
  );
};

export default CatalogSampleThumbnail;
